<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Editar Submotivo</h5>
        </div>        
        <emt-form ref="subreason-form" v-bind:resource="config.api + '/subreason/'" v-bind:items="itemsForm" v-bind:updateData="update"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'

export default{
    name: 'emt-form-edit-subreason',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Submotivo',
                    'placeholder': 'Ingrese submotivo',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'reason',
                    'label': 'Motivo',
                    'placeholder': 'Seleccione un motivo',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }
            ],
            config: Config,
            update: true
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getReason()
    },
    methods: {
        getData: function (url) {
            url = url + this.$route.params.id + '/'
            let self = this
            self.$http.get(url).then(function (response) {
                self.setValue(response.body)
            }, function (response) {
            })
        },
        setValue: function (value) {
            let self = this
            for (var form in this.itemsForm) {
                if (this.itemsForm[form].name === 'reason') {
                    var activeOptions = self.itemsForm[form].select_options
                    var flag = false
                    for (var i = 0; i < activeOptions.length; i++) {
                        if (activeOptions[i].value === value[self.itemsForm[form].name]) {
                            self.itemsForm[form].value = value[self.itemsForm[form].name]
                            flag = true
                        }
                    }
                    if (!flag) {
                        self.itemsForm[form].value = ''
                    }
                } else {
                    this.itemsForm[form].value = value[this.itemsForm[form].name]
                }
            }
        },
        /*
        *esta funcion permite consultar y listar los motivos
        */
        getReason: function () {
            var self = this
            self.$http.get(Config.api + '/reason/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
                this.getData(Config.api + '/subreason/')
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-edit-subreason.vue?c815c360